module.exports = __webpack_public_path__ + "img/welcome.9fa06e93.png";